import * as React from "react";
import { userProfile } from "../../../../../../common";

// --

const logoUrls: Record<userProfile.TProvider, string> = {
	google: "/img/branding/cdnlogo.com_google-icon.svg",
	microsoft: "/img/branding/ms-symbollockup_mssymbol_19.svg",
	linkedin: "/img/branding/LI-In-Bug.png",
};

const ExtProvLabel: Record<userProfile.TProvider, string> = {
	google: "Google",
	microsoft: "Microsoft",
	linkedin: "LinkedIn",
};

/**
 * ExtAuthProviderBtn
 * @param props
 * @returns
 */
export const ExtAuthProviderBtn: React.FC<{
	readonly provider: userProfile.TProvider;
	readonly text: string;
	onClick(ev?: React.MouseEvent): void;
}> = (props) => {
	return (
		<button className='ext-auth-provider-btn' onClick={props.onClick}>
			<img src={logoUrls[props.provider]} />

			<span>
				{props.text} {ExtProvLabel[props.provider]}
			</span>
		</button>
	);
};
